import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { commonStyles } from 'shared/styles/enhancedTheme';

const BackButton = ({ 
  onClick, 
  tooltip,
  position = "padding-area", // "top-left", "inline", "floating", "padding-area"
  sx = {},
  ...props 
}) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  const getPositionStyles = () => {
    switch (position) {
      case "inline":
        return {
          color: 'text.secondary',
          transition: 'all 0.2s ease',
          '&:hover': {
            color: 'primary.main',
            backgroundColor: 'action.hover',
            transform: 'translateX(-2px)',
          }
        };
      case "padding-area":
        return {
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
        };
      case "top-left":
        return {
          position: 'absolute',
          top: 16,
          left: 16,
          zIndex: 10,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(0,0,0,0.08)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            transform: 'translateY(-1px)',
            boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
          }
        };
      case "floating":
        return {
          position: 'fixed',
          top: 100,
          left: 16,
          zIndex: 1200,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(0,0,0,0.08)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            transform: 'translateY(-1px)',
            boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
          }
        };
      default:
        return commonStyles.backButton;
    }
  };

  const button = (
    <IconButton
      onClick={handleClick}
      sx={{
        ...getPositionStyles(),
        ...sx
      }}
      {...props}
    >
      <ArrowBackIcon />
    </IconButton>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow placement="right">
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default BackButton;